import type { BuiltinTokenMap } from '@visactor/vchart';

export const token: Partial<BuiltinTokenMap> = {
  fontFamily:
    // eslint-disable-next-line max-len
    'Inter,-apple-system,BlinkMacSystemFont,PingFang SC,Hiragino Sans GB,noto sans,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif'
};
